export default __webpack_public_path__ + "static/media/high-speed.6762a3d3.png";